module.exports = __webpack_public_path__ + "static/video-poster-0c91d6c8f1e37c77f4619ed9b60df27b.png";